<template>
  <div>
    <el-table
        :data="tableData"
        class="zebra-table"
        style="width: 100%">
      <el-table-column
          :sortable="!newSubscription"
          label="Услуга"
          :width="newSubscription ? '240' : ''">

        <template slot-scope="scope">
          <el-select v-if="newSubscription"
                     v-model="tableData[scope.$index].procedure_id"
                     style="width: 100%;"
                     @change="changeData"
                     class="select"
                     placeholder="Выберите">
            <el-option
                v-for="type of serviceTypes"
                :key="type.id"
                :value="type.id"
                :label="type.title"/>
          </el-select>
          <div v-else><p v-if="scope.row.procedure">{{ scope.row.procedure.title }}</p></div>
        </template>

      </el-table-column>
      <el-table-column
          prop="date"
          :sortable="!newSubscription"
          :label="newSubscription ? '' : 'Всего посещений'"
          align="left"
      >
        <template slot-scope="scope">
          <p v-if="!newSubscription">{{ scope.row.total }}</p>
          <el-input-number
              v-else
              v-model="tableData[scope.$index].total"
              @change="changeData"
              :min="0"
              :max="999999"
              style="width: 100%"/>
        </template>
      </el-table-column>
      <el-table-column
          :sortable="!newSubscription"
          prop="accomplished"
          label="Пройдено посещений"
          align="left"
          v-if="!newSubscription"
      />
      <el-table-column align="right" v-if="newSubscription">
        <template slot-scope="scope">
         <div class="price">{{ getSumm(scope.row) }} ₽</div>
        </template>
      </el-table-column>

    </el-table>


  </div>
</template>

<script>
export default {
  name: "SubscriptionTable",
  props: {
    subscription: {},
    serviceTypes: {},
    newSubscription: {},
    user: {
      require: true,
    },
  },
  data() {
    return {
      tableData: [{total: 0}],
      membershipId: null,
    }
  },
  components: {},
  computed: {},
  methods: {
    getSumm(value) {
      if(!value.procedure_id) return 0


      return this.findById(value.procedure_id).price * value.total
    },
    findById(id) {
      return this.serviceTypes.find(item => item.id === id)
    },
    addEmptyField(value) {
      if (!value) return

      if (Object.keys(value).length) {
        let data = JSON.parse(JSON.stringify(value))
        this.tableData = data.user_membership_procedure
        this.membershipId = data.id
      }
    },
    changeData() {
      //let payLoad = [...this.tableData]
      //   payLoad.splice(payLoad.length - 1, 1)
      this.$emit('updateServiceTypes', JSON.parse(JSON.stringify(this.tableData)))
    }
  },
  watch: {
    subscription(value) {
      this.addEmptyField(value)
    },
    tableData(value) {
      // // Добавление строки если процедур вообще нет
      if (!value.length && this.newSubscription) {
        value.push({total: 0})
        return
      }
      //
      // // Автодобавление новой после заполеннеия предыдущей
      if (value[value.length - 1] && value[value.length - 1].procedure_id && this.newSubscription) {
        value.push({total: 0})
      }
    }
  },
  mounted() {
    this.addEmptyField(this.subscription)
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.btn {
  margin-top: 12px;
}

.select {
  max-width: 240px;
}
.price {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  color: #676767;
}
</style>
